import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-top":"100px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Buy Flex")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("From")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("To")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Regulation type")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Up")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Down")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Quantity")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("KW/h")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Price")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("NOK")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_flat_pickr = _resolveComponent("flat-pickr")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.edit)
      ? (_openBlock(), _createBlock(_component_ion_text, {
          key: 0,
          style: {"font-size":"1.5rem"}
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_ion_grid, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    style: _normalizeStyle(_ctx.edit ? 'color: grey' : '')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_flat_pickr, {
                        id: "periodFrom",
                        disabled: _ctx.edit,
                        config: _ctx.datePickerConfig,
                        modelValue: _ctx.form.periodFrom,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.periodFrom) = $event)),
                        onOnClose: _ctx.handleNewFromDate,
                        class: "datepicker"
                      }, null, 8, ["disabled", "config", "modelValue", "onOnClose"]),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.calendarClearOutline,
                        size: "small",
                        slot: "end"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    style: _normalizeStyle(_ctx.edit ? 'color: grey' : '')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_flat_pickr, {
                        disabled: _ctx.edit,
                        id: "periodTo",
                        config: _ctx.datePickerConfig,
                        modelValue: _ctx.form.periodTo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.periodTo) = $event)),
                        onOnClose: _ctx.handleNewToDate,
                        class: "datepicker"
                      }, null, 8, ["disabled", "config", "modelValue", "onOnClose"]),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.calendarClearOutline,
                        size: "small",
                        slot: "end"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        interface: "popover",
                        disabled: _ctx.edit,
                        id: "regulationType",
                        "selected-text": _ctx.form.regulationType,
                        modelValue: _ctx.form.regulationType,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.regulationType) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "Up" }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "Down" }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled", "selected-text", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        id: "quantity",
                        required: "",
                        type: "number",
                        min: "1",
                        modelValue: _ctx.form.quantity,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.quantity) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        id: "price",
                        required: "",
                        type: "number",
                        min: "1",
                        modelValue: _ctx.form.unitPrice,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.unitPrice) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, {
                        color: _ctx.message.error ? 'danger' : 'success'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.message.text), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        type: "submit",
                        slot: "end"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.edit ? "Update" : "Buy"), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.edit)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            type: "button",
                            slot: "end",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (this.$emit('cancel')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 32)
  ]))
}